const SHANGHAI_OFFSET_MS = 8 * 60 * 60 * 1000

export function parseTime(value) {
  if (value === null || value === undefined || value === '') {
    return null
  }

  if (value instanceof Date) {
    return isNaN(value.getTime()) ? null : value
  }

  if (typeof value === 'number' || /^\d+(\.\d+)?$/.test(String(value).trim())) {
    let timestamp = Number(value)
    if (!isFinite(timestamp)) {
      return null
    }
    // 10 位时间戳为秒，13 位时间戳为毫秒。
    if (Math.abs(timestamp) < 100000000000) {
      timestamp *= 1000
    }
    const numericDate = new Date(timestamp)
    return isNaN(numericDate.getTime()) ? null : numericDate
  }

  const text = String(value).trim()
  // 后端常用的 yyyy-MM-dd HH:mm:ss / yyyy/MM/dd HH:mm:ss 均按东八区解释，
  // 避免不同浏览器和操作系统用各自本地时区解析。
  const localMatch = text.match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})(?:[ T](\d{1,2})(?::(\d{1,2}))?(?::(\d{1,2}))?(?:\.(\d{1,3}))?)?$/)
  if (localMatch) {
    const milliseconds = Number(((localMatch[7] || '0') + '000').slice(0, 3))
    const timestamp = Date.UTC(
      Number(localMatch[1]),
      Number(localMatch[2]) - 1,
      Number(localMatch[3]),
      Number(localMatch[4] || 0) - 8,
      Number(localMatch[5] || 0),
      Number(localMatch[6] || 0),
      milliseconds
    )
    const localDate = new Date(timestamp)
    return isNaN(localDate.getTime()) ? null : localDate
  }

  // 带 Z 或显式时区偏移的 ISO 时间按其自身时区解析，再统一转东八区展示。
  const parsedTimestamp = Date.parse(text)
  if (isNaN(parsedTimestamp)) {
    return null
  }
  return new Date(parsedTimestamp)
}

function pad(value) {
  return value < 10 ? '0' + value : String(value)
}

export default {
  getDate(time, type) {
    const date = parseTime(time)
    if (!date) {
      return ''
    }

    // 使用 UTC getter 读取加上八小时后的时间，确保任何运行环境都按东八区显示。
    const shanghaiDate = new Date(date.getTime() + SHANGHAI_OFFSET_MS)
    const year = shanghaiDate.getUTCFullYear()
    const month = pad(shanghaiDate.getUTCMonth() + 1)
    const day = pad(shanghaiDate.getUTCDate())
    const hour = pad(shanghaiDate.getUTCHours())
    const minute = pad(shanghaiDate.getUTCMinutes())
    const second = pad(shanghaiDate.getUTCSeconds())
    const dateText = year + '-' + month + '-' + day
    const hourMinuteText = ' ' + hour + ':' + minute

    if (type == 1) {
      return dateText + hourMinuteText + ':' + second
    } else if (type == 2) {
      return dateText
    } else if (type == 3) {
      return dateText + hourMinuteText
    } else if (type == 4) {
      return hourMinuteText + ':' + second
    } else if (type == 5) {
      return ' ' + hour + ':00'
    } else if (type == 6) {
      return hourMinuteText
    } else if (type == 7) {
      return month + '-' + day + hourMinuteText
    } else if (type == 8) {
      const week = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
      return week[shanghaiDate.getUTCDay()]
    } else if (type == 9) {
      return day
    }

    return dateText + hourMinuteText + ':' + second
  }
}



// WEBPACK FOOTER //
// ./src/assets/utils/time.js